import { Modal } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";

import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";
import save from "../../../assets/save-icon.png";
import cancel from "../../../assets/cancel-icon.png";

const RegisterRoles = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [addData, setAddData] = useState([]);
  const [inputError, setInputError] = useState([]);

  const roleNameInputRef = useRef();
  const remarkInputRef = useRef();

  const hideModal = () => {
    setAddData([]);
    setInputError([]);
    props.onHide();
  };

  const saveBtnOnClick = () => {
    var flag = true;
    if (addData.ROLE_NAME === undefined) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        ROLE_NAME: " Role name could not be empty.",
      }));
    }

    if (
      Object.values(inputError).filter((v) => v !== "").length === 0 &&
      flag
    ) {
      RegisterNewRole();
    }
  };

  function RegisterNewRole() {
    let functionName = "";
    try {
      functionName = props.page + RegisterNewRole.name;
      props.onLoading(true, "Registering role, please wait...");
      const data = {
        ROLE_NAME: addData.ROLE_NAME.trim(),
        REMARK: addData.REMARK === undefined ? "" : addData.REMARK.trim(),
        UPDATE_ID: userId,
        FROM_SOURCE: { SOURCE: "WEB" /*MODULE_ID: props.module*/ },
      };
      http
        .post("api/roles/RegisterRole", data, { timeout: 10000 })
        .then((response) => {
          if (response.data.DUPLICATE_ROLE_NAME === true) {
            toast.error("Role name already exist.");
          } else {
            toast.success("Role is successfully inserted.");
            props.onReload();
            hideModal();
          }
        })
        .catch((err) => {
          toast.error("Failed to insert role. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      toast.error("Failed to insert role. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
      setAddData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const inputUnrequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputUnrequiredHandler.name;
      const id = event.target.id;
      const val = event.target.value;

      setAddData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "lightgrey", width: "100%" }}>
            <Modal.Title>REGISTER</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Comp.Input
            ref={roleNameInputRef}
            id="ROLE_NAME"
            label="Role Name*:"
            name="User Role"
            type="text"
            className="form-control"
            errorMessage={inputError.ROLE_NAME}
            value={addData.ROLE_NAME}
            onChange={inputRequiredHandler}
          />
          <Comp.Input
            ref={remarkInputRef}
            id="REMARK"
            label="Remark:"
            name="Remark"
            type="text"
            className="form-control"
            errorMessage={inputError.REMARK}
            value={addData.REMARK}
            onChange={inputUnrequiredHandler}
          />
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Comp.Button id="btnSave" type="general" onClick={saveBtnOnClick}>
              Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <Comp.Button id="btnCancel" type="cancel" onClick={hideModal}>
              Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RegisterRoles;
